import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowRight, FileSearch } from "lucide-react";
import { FeatureShowcase } from "./FeatureShowcase";

export const Hero = () => {
  return (
    <section className="relative py-16 lg:py-24">
      <div className="container relative z-10 mx-auto px-4">
        <div className="mx-auto max-w-3xl text-center">
          <h1 className="mb-5 text-4xl font-bold tracking-tight sm:text-5xl lg:text-6xl">
            SentinelAI
          </h1>

          <p className="mx-auto mb-8 max-w-xl text-lg text-muted-foreground sm:text-xl">
            SentinelAI researches markets, IP, supply chains and regulation, then
            gives you one cited, export-ready report.
          </p>

          <div className="flex flex-col items-center justify-center gap-3 sm:flex-row">
            <Button size="lg" className="gap-2 px-8 text-base font-semibold" asChild>
              <Link to="/auth?mode=signup">
                Create free account
                <ArrowRight className="h-4 w-4" />
              </Link>
            </Button>
            <Button size="lg" variant="outline" className="gap-2" asChild>
              <Link to="/samples">
                <FileSearch className="h-4 w-4" />
                View Sample Report
              </Link>
            </Button>
          </div>

          <p className="mt-6 text-sm text-muted-foreground">
            7-day free Premium trial when you sign up · Cancel before day 7 to avoid being charged · Billed £199/month after, non-refundable
          </p>
        </div>

        <FeatureShowcase />
      </div>
    </section>
  );
};
